import { PaintedScene } from '../PaintedScene';

export const THE_MEADOW_PHASER_KEY = 'TheMeadowScene' as const;
export const THE_MEADOW_MANIFEST_KEY = 's-007-the-meadow' as const;

export class TheMeadowScene extends PaintedScene {
  constructor() {
    super(THE_MEADOW_PHASER_KEY, THE_MEADOW_MANIFEST_KEY);
  }
}
